import * as React from "react";
import { styled } from "@mui/material/styles";
import { TextField as MuiTextField, TextFieldProps } from "@mui/material";

const SketchyTextField = styled((props: any) => <MuiTextField {...props} />)(({ theme }) => ({
    "& .MuiOutlinedInput-root": {
        borderRadius: "255px 15px 225px 15px / 15px 225px 15px 255px",
        fontFamily: '"Short Stack", "Caveat", cursive',
        fontSize: 14,
        "& fieldset": {
            border: "var(--fq-sketch-border)",
            borderRadius: "255px 15px 225px 15px / 15px 225px 15px 255px",
        },
        "&:hover fieldset": {
            borderColor: theme.palette.primary.main,
        },
        "&.Mui-focused fieldset": {
            border: "2px solid " + theme.palette.primary.main,
            boxShadow: "2px 2px 0px " + theme.palette.primary.main,
        },
    },
    "& .MuiInputBase-input": {
        fontFamily: '"Short Stack", "Caveat", cursive',
        fontSize: 14,
    },
}));

export default function TextFieldAutocomplete(props: TextFieldProps) {
    return <SketchyTextField size={"small"} {...props} />;
}
